import { Injectable } from '@angular/core';

@Injectable()
export class AutomationCredentialsService {

  constructor() { }

  updateCredentialsS3(executionContext, accessKeyId, secretAccessKey){
    executionContext.WorkItem.Arguments.InputArguments.forEach(argument => {
        if(argument.StorageProvider === "S3"){
                argument.Headers =  [{   
                    "Name":"AccessKeyId",
                    "Value": accessKeyId
                },{
                    "Name":"SecretAccessKey",
                    "Value": secretAccessKey
                }];
        }
    });
    executionContext.WorkItem.Arguments.OutputArguments.forEach(argument => {
        if(argument.StorageProvider === "S3"){
                argument.Headers =  [{   
                    "Name":"AccessKeyId",
                    "Value": accessKeyId
                },{
                    "Name":"SecretAccessKey",
                    "Value": secretAccessKey
                }];
        }
    });
  }

  updateCredentialsHsbShare(executionContext, accessToken){
    executionContext.WorkItem.Arguments.InputArguments.forEach(argument => {
        if(argument.StorageProvider === "HsbShare"){
                argument.Headers =  [{   
                    "Name":"AccessToken",
                    "Value": accessToken
                }];
        }
    });
    executionContext.WorkItem.Arguments.OutputArguments.forEach(argument => {
        if(argument.StorageProvider === "HsbShare"){
                argument.Headers = [{   
                    "Name":"AccessToken",
                    "Value": accessToken
                }];
        }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/automation-credentials.service.ts